import { init } from '@dash0hq/sdk-web';
import { getCurrentBrand } from '~/config/branding-utils';
import { loadConfig } from './config';

const SENSITIVE_URL_PATTERNS = [
  /\/peer_reference\/code\//i,
  /\/peerReference\//i,
  /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b/i,
  /[?&](token|npi|ssn|license|dea|code)=/i,
];

export function initObservability(): void {
  const config = loadConfig();
  if (!config.enabled) return;

  const currentUrl = currentPageUrl();
  if (currentUrl && isSensitiveTelemetryUrl(currentUrl)) {
    console.warn('[observability] Dash0 frontend SDK skipped for sensitive entry URL');
    return;
  }

  init({
    serviceName: 'mcv-client',
    serviceVersion: config.serviceVersion,
    environment: config.environment,
    endpoint: {
      url: config.endpoint,
      authToken: config.token,
      dataset: config.environment,
    },
    // Attached to every signal so unauthenticated traffic still carries
    // them; user-scoped attrs come from identifyUser() post-auth.
    additionalSignalAttributes: {
      'app.brand': getCurrentBrand(),
      'app.version': config.serviceVersion,
    },
    // SDK v0.6.1 has no URL scrubber hook. Fetch URLs matching the
    // sensitive set are dropped; sensitive entry URLs skip SDK startup above.
    ignoreUrls: [/\/health$/, /\/api\/health$/, /\/schema/, /\/ci$/, ...SENSITIVE_URL_PATTERNS],
    pageViewInstrumentation: {
      trackVirtualPageViews: false,
    },
  });
}

function currentPageUrl(): string | undefined {
  return typeof window === 'undefined' ? undefined : window.location.href;
}

function isSensitiveTelemetryUrl(url: string): boolean {
  return SENSITIVE_URL_PATTERNS.some((pattern) => pattern.test(url));
}
